import React, { useState } from 'react';
import styled from 'styled-components';

const FormContainer = styled.div`
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 8px;
  margin-top: 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
`;

const ColorInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 4px;
`;

const PreviewContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #ddd;
`;

const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  display: block;
  margin: 0 auto;
`;

const PersonalizacaoForm = ({ 
  onPersonalizacaoChange, 
  fileId, 
  idRede,
  previewUrl 
}) => {
  const [personalizacao, setPersonalizacao] = useState({
    texto: '',
    posicao_texto: 'bottom',
    cor_texto: '#000000',
    tamanho_texto: 24,
    moldura_id: '',
    logo_id: '',
    posicao_logo: 'bottom-right',
    tamanho_logo: 20
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === 'tamanho_texto' || name === 'tamanho_logo' 
      ? parseInt(value) 
      : value;
    
    const newPersonalizacao = {
      ...personalizacao,
      [name]: newValue
    };
    
    setPersonalizacao(newPersonalizacao);
    onPersonalizacaoChange(newPersonalizacao);
  };

  return (
    <FormContainer>
      <FormGroup>
        <Label>Texto</Label>
        <Input
          type="text"
          name="texto"
          value={personalizacao.texto}
          onChange={handleChange}
          placeholder="Digite o texto"
        />
      </FormGroup>

      <FormGroup>
        <Label>Posição do Texto</Label>
        <Select
          name="posicao_texto"
          value={personalizacao.posicao_texto}
          onChange={handleChange}
        >
          <option value="top">Topo</option>
          <option value="center">Centro</option>
          <option value="bottom">Inferior</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label>Cor do Texto</Label>
        <ColorInput
          type="color"
          name="cor_texto"
          value={personalizacao.cor_texto}
          onChange={handleChange}
        />
      </FormGroup>

      <FormGroup>
        <Label>Tamanho do Texto</Label>
        <Input
          type="number"
          name="tamanho_texto"
          value={personalizacao.tamanho_texto}
          onChange={handleChange}
          min="8"
          max="72"
        />
      </FormGroup>

      <FormGroup>
        <Label>Posição do Logo</Label>
        <Select
          name="posicao_logo"
          value={personalizacao.posicao_logo}
          onChange={handleChange}
        >
          <option value="top-left">Superior Esquerdo</option>
          <option value="top-right">Superior Direito</option>
          <option value="bottom-left">Inferior Esquerdo</option>
          <option value="bottom-right">Inferior Direito</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label>Tamanho do Logo (%)</Label>
        <Input
          type="number"
          name="tamanho_logo"
          value={personalizacao.tamanho_logo}
          onChange={handleChange}
          min="5"
          max="50"
        />
      </FormGroup>

      {previewUrl && (
        <PreviewContainer>
          <h3>Prévia</h3>
          <PreviewImage src={previewUrl} alt="Prévia da imagem" />
        </PreviewContainer>
      )}
    </FormContainer>
  );
};

export default PersonalizacaoForm; 